<bn-account-detail-base [product]="product"
                        [hostRef]="hostRef"
                        [productNumberFormat]="productNumberFormat"
                        [title1]="title1"
                        [title2]="title2"
                        [title3]="title3">
  <div details>
    <div class="account-detail-base__item">
      <div>
        <strong i18n="@@product.details.totalBalance">Total balance</strong>
      </div>
      <div>{{ product?.additions?.totalBalance | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
    </div>
    <div class="account-detail-base__item">
      <div>
        <strong i18n="@@product.details.maturityInterest">Maturity interest</strong>
      </div>
      <div>{{ product?.maturityAmount | bnCurrencyPipe:product?.additions?.currencyCode  }}</div>
    </div>
  </div>

  <div row2
       class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item account-detail-base__item--blue">
        <div><strong i18n="@@product.details.openingAmount">Opening amount</strong></div>
        <div>{{ product?.additions?.originalAmount | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.term">Term</strong></div>
        <div>{{ product?.termNumber | bnEmpty:'--' }} {{ product?.termUnit | bnEmpty:'--' }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.interestRate">Interest rate</strong></div>
        <div *ngIf="product?.accountInterestRate != -1">{{ product?.accountInterestRate  }}%</div>
        <div *ngIf="product?.accountInterestRate == -1">--</div>
      </div>
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.accruedInterest">Accrued interest</strong>
        </div>
        <div>{{ product?.additions?.paidInterest | bnCurrencyPipe:product?.additions?.currencyCode }}</div>
      </div>
    </div>
  </div>

  <div row3
       class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.accountManager">Account manager</strong>
        </div>
        <div>{{ product?.additions?.accountOfficialName | bnEmpty:'--' }}</div>
      </div>
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.interestType">Interest type</strong>
        </div>
        <div>{{ product?.additions?.methodOfPayment | bnEmpty:'--' }}</div>
      </div>
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.startdate">Start date</strong>
        </div>
        <div *ngIf="product?.accountOpeningDate != -1">{{ product?.accountOpeningDate | bnEsDate }}</div>
        <div *ngIf="product?.accountOpeningDate == -1">--</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.accountBranch">Account branch</strong>
        </div>
        <div>{{ product?.additions?.bankBranchCode | bnEmpty:'--' }}</div>
      </div>
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.interestSettlementAccount">Interest settlement account</strong>
        </div>
        <div>{{ product?.additions?.interestPaymentAccount | bnEmpty:'--' }}</div>
      </div>
      <div class="account-detail-base__item">
        <div>
          <strong i18n="@@product.details.maturityDate">Maturity date</strong>
        </div>
        <div>{{ product?.additions?.expiryDate | bnEsDate }}</div>
      </div>
    </div>
  </div>

</bn-account-detail-base>
